// Opens and closes the full-screen main menu in the shared header
// (templates/partials/_header.html.twig). Listeners are delegated on the
// document because Turbo replaces the header on every visit. The open
// state lives on <html> (which Turbo keeps), so it is cleared before Turbo
// caches a page.
export function installMenu(root = document) {
  const html = root.documentElement
  const find = (selector) => root.querySelector(selector)
  const isOpen = () => html.classList.contains('menu-open')

  function setOpen(open, { restoreFocus = false } = {}) {
    const toggle = find('[data-menu-toggle]')
    html.classList.toggle('menu-open', open)
    toggle?.setAttribute('aria-expanded', String(open))
    const label = find('[data-menu-label]')
    if (label) label.textContent = open ? 'Close' : 'Menu'

    if (open) find('[data-menu-panel]')?.focus({ preventScroll: true })
    else if (restoreFocus) toggle?.focus({ preventScroll: true })
  }

  function onClick(event) {
    if (!(event.target instanceof Element) || !event.target.closest('[data-menu-toggle]')) return
    setOpen(!isOpen())
  }

  function onKeydown(event) {
    if (!isOpen()) return

    if (event.key === 'Escape') {
      setOpen(false, { restoreFocus: true })
      return
    }

    // Keep Tab inside the header (logo, toggle, menu links) while open.
    if (event.key !== 'Tab') return
    const header = find('[data-menu]')
    if (!header) return
    const focusable = [...header.querySelectorAll('a[href], button:not([disabled])')]
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    const active = root.activeElement
    const inside = header.contains(active)

    if (event.shiftKey && (active === first || !inside || active === find('[data-menu-panel]'))) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && (active === last || !inside)) {
      event.preventDefault()
      first.focus()
    }
  }

  function onBeforeCache() {
    if (isOpen()) setOpen(false)
  }

  root.addEventListener('click', onClick)
  root.addEventListener('keydown', onKeydown)
  root.addEventListener('turbo:before-cache', onBeforeCache)

  return () => {
    root.removeEventListener('click', onClick)
    root.removeEventListener('keydown', onKeydown)
    root.removeEventListener('turbo:before-cache', onBeforeCache)
  }
}
